<mat-toolbar>
  <mat-icon>timeline</mat-icon> Service Monitor Charts
  <span class="fill-space"></span>
  <button mat-icon-button mat-tooltip="Refresh" (click)="smChart.refreshChart()"><mat-icon>refresh</mat-icon></button>
</mat-toolbar>
<micro-sm-chart #smChart cols="2" persist="true" [showChartSelect]="true" [reloadInterval]="60000"></micro-sm-chart>
